<template>
    <div class="manifest-filters-container">
        <md-datepicker v-model="fromDate" md-immediately :md-debounce="100" class="filter-date-picker">
            <label>From Date</label>
        </md-datepicker>
        <md-datepicker v-model="toDate" md-immediately :md-debounce="100" class="filter-date-picker">
            <label>To Date</label>
        </md-datepicker>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'ManifestTableFilters',
    props: {
        initialFromDate: {
            type: Date,
            default: null
        },
        initialToDate: {
            type: Date,
            default: null
        }
    },
    data() {
        // Set default values: yesterday to 7 days after yesterday
        const defaultFromDate =
            this.initialFromDate ||
            moment()
                .subtract(1, 'days')
                .toDate();
        const defaultToDate =
            this.initialToDate ||
            moment()
                .subtract(1, 'days')
                .add(7, 'days')
                .toDate();

        return {
            fromDate: defaultFromDate,
            toDate: defaultToDate
        };
    },
    watch: {
        initialFromDate(newVal) {
            if (newVal) {
                this.fromDate = newVal;
            }
        },
        initialToDate(newVal) {
            if (newVal) {
                this.toDate = newVal;
            }
        },
        fromDate(newVal) {
            this.emitFilterChange();
        },
        toDate(newVal) {
            this.emitFilterChange();
        }
    },
    mounted() {
        // Emit initial filter values on mount
        this.emitFilterChange();
    },
    methods: {
        emitFilterChange() {
            this.$emit('filter-changed', {
                fromDate: this.fromDate,
                toDate: this.toDate
            });
        },
        validateDateRange() {
            if (this.fromDate && this.toDate) {
                const from = moment(this.fromDate);
                const to = moment(this.toDate);

                if (from.isAfter(to)) {
                    this.$notify({
                        message: 'From date cannot be after To date.',
                        type: 'warning'
                    });
                    return false;
                }
            }
            return true;
        }
    }
};
</script>

<style lang="scss" scoped>
.manifest-filters-container {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 16px;

    .filter-field {
        min-width: 160px;

        .md-field {
            margin: 0;
            min-height: 48px;
        }

        .filter-date-picker {
            font-size: 14px;
        }
    }
}

::v-deep .md-datepicker:after,
::v-deep .md-datepicker:before {
    bottom: 0;
    height: 0;
}

::v-deep .md-datepicker:before,
::v-deep .md-datepicker:after {
    bottom: 30px;
    color: #aaaaaa;
    font-weight: 400;
    font-size: 14px;
    transform: none;
    z-index: 1;
}

// Responsive design
@media (max-width: 768px) {
    .manifest-filters-container {
        flex-direction: column;
        align-items: stretch;
        gap: 12px;

        .filter-field {
            min-width: 100%;
        }
    }
}
</style>
